import React from "react";
import Contact from "../../../assets/img/home/contact-banner-new.jpg"
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

function Contact_banner(){
    return(
      <>
      <Helmet> <title>Contact | GreenDart Builders</title> </Helmet>
        <div className="page-title" style={{ backgroundImage: `url(${Contact})`}}>
      {/* <div className="container position-relative">
        <h1 className="sub-banner-header">Contact Us</h1>
        <nav className="breadcrumbs">
          <ol>
            <li><Link className="text-white" to="/">Home</Link></li>
            <li className="current">Contact Us</li>
          </ol>
        </nav>
      </div> */}
    </div>
      </>

    )
}
export default Contact_banner;